import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import {
  IStrapiDocument,
  Policy,
  PrivacyPolicy,
} from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { NgIf, NgFor } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { BannerComponent } from '../../../shared/components/banner/banner.component';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbsComponent,
        NgIf,
        BannerComponent,
        PageRetrievalErrorComponent,
        NgFor,
        RenderMarkdownComponent,
    ],
})
export class PrivacyPolicyComponent extends PageComponent implements OnInit {
  public override pageData: PrivacyPolicy = <PrivacyPolicy>{};

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  public selection = new SelectionModel<Policy>(true, []);

private cdr = inject(ChangeDetectorRef);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentByUID('privacy-policy', 'privacy-notice', {
        populate: {
          policies: { populate: '*' },
          banner: {
            populate: {
              slides: { populate: ['image'] },
            },
          },
        },
      })
      .subscribe({
        next: (data: IStrapiDocument<PrivacyPolicy>) => {
          this.parsePageData(data.data.attributes);
          super.setMetas();
          this.cdr.markForCheck();
        },
        error: () => {
          this.pageRetrievalError = true;
        },
      });
  }

  protected override parsePageData(page: PrivacyPolicy): void {
    super.parsePageData(page);

    this.pageData.policies = page.policies;
  }
}
